<script setup lang="ts">
interface props {
  src?: string
  class?: string | object | string[]
  alt?: string
}

const props = defineProps<props>()

const alt = computed(() => props.alt ?? props.src?.split('/').pop() ?? props.src)
</script>

<template>
  <img
    v-if="src"
    :src
    :alt="alt"
    :class="props.class"
  />
</template>
